import { View } from 'react-native';
import { Icon } from './Icon';
import colors from '@/config/colors';

type Props = {
  status: 'correct' | 'wrong';
};

export const FeedBack = ({ status }: Props) => {
  const isCorrect = status === 'correct';
  const iconName = isCorrect ? 'like' : 'dislike';
  const bgColor = isCorrect ? 'bg-green-neolexon' : 'bg-red-500';

  return (
    <View
      className={`absolute top-1 right-1 w-20 aspect-square ${bgColor} rounded-full justify-center items-center`}
    >
      <Icon name={iconName} color={colors.lightBlue} size={40} />
    </View>
  );
};
